import React from "react";
import _str from "shared/util/_str";

const guestLinks = [
	{
		href: "/s/chicago-dating",
		name: "Chicago Dating",
	},
	{
		href: "/s/washington-dating",
		name: "Washington Dating",
	},
	{
		href: "/s/seattle-dating",
		name: "Seattle Dating",
	},
	{
		href: "/s/los-angeles-dating",
		name: "Los Angeles Dating",
	},
	{
		href: "/s/philadelphia-dating",
		name: "Philadelphia Dating",
	},
	{
		href: "/s/atlanta-dating",
		name: "Atlanta Dating",
	},
	{
		href: "/s/nyc-dating",
		name: "NYC Dating",
	},
	{
		href: "/s/christian-singles",
		name: "Christian Singles",
	},
	{
		href: "/s/jewish-singles",
		name: "Jewish Singles",
	},
	{
		href: "/s/spiritual-singles",
		name: "Spiritual Singles",
	},
	{
		href: "/s/muslim-dating",
		name: "Muslim Dating",
	},
	{
		href: "/s/gay-dating",
		name: "Gay Dating",
	},
	{
		href: "/s/bisexual-dating",
		name: "Bisexual Dating",
	},
	{
		href: "/s/lesbian-dating",
		name: "Lesbian Dating",
	},
	{
		href: "/s/liberal-dating-sites",
		name: "Liberal Dating",
	},
	{
		href: "/s/vegan-dating",
		name: "Vegan Dating",
	},
	{
		href: "/s/vegetarian-dating",
		name: "Vegetarian Dating",
	},
	{
		href: "/s/conservative-dating-sites",
		name: "Conservative Dating",
	},
];

export const links = [
	{
		name: _str("Apps"),
		href: "/mobile",
	},
	{
		name: _str("About"),
		href: "/about",
	},
	{
		name: _str("Ad Choices"),
		href: "/legal/privacy#third-parties",
	},
	{
		name: _str("Press"),
		href: "/press",
	},
	{
		name: _str("Careers"),
		href: "/careers",
	},
	{
		name: _str("Support"),
		href: "https://help.okcupid.com",
	},
	{
		name: _str("Blog"),
		href: "https://theblog.okcupid.com",
	},
	{
		name: _str("Tech Blog"),
		href: "https://tech.okcupid.com",
	},
	guestLinks[Math.floor(Math.random() * guestLinks.length)],
	{
		name: _str("Privacy Policy"),
		href: "/legal/privacy",
	},
	{
		name: _str("Cookie Policy"),
		href: "/legal/cookies",
	},
	{
		name: _str("Terms"),
		href: "/legal/terms",
	},
	{
		name: _str("Community Guidelines"),
		href: "https://help.okcupid.com/article/142-community-guidelines",
	},
	{
		name: _str("Safety Tips"),
		href: "/legal/safety-tips",
	},
];

const Footer = () => (
	<div className="splashdtf-footer">
		<div className="splashdtf-footer-links">
			<ul className="splashdtf-footer-nav">
				{links.map((link) => (
					<li key={link.href} className="splashdtf-footer-nav-item">
						<a className="splashdtf-footer-nav-item-link" href={link.href}>
							{link.name}
						</a>
					</li>
				))}
			</ul>

			<div className="splashdtf-footer-copyright">
				© OkCupid {new Date().getFullYear()}
			</div>
		</div>
		<div className="splashdtf-footer-social">
			<a
				className="splashdtf-footer-social-circle facebook"
				target="_blank"
				rel="noopener noreferrer"
				href="https://facebook.com/okcupid"
			>
				<i className="okicon i-facebook" />
			</a>
			<a
				className="splashdtf-footer-social-circle instagram"
				target="_blank"
				rel="noopener noreferrer"
				href="https://instagram.com/okcupid"
			>
				<i className="okicon i-instagram" />
			</a>
			<a
				className="splashdtf-footer-social-circle twitter"
				target="_blank"
				rel="noopener noreferrer"
				href="https://twitter.com/okcupid"
			>
				<i className="okicon i-twitter" />
			</a>
		</div>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/components/Footer.jsx